import { ExternalSupplierProfilePanel } from "@/components/organisms";

export const ExternalSupplierProfile = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <ExternalSupplierProfilePanel />
    </div>
  );
};
